import React from "react";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Button } from "@/components/ui/button";
import { UserPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ClientFieldsProps {
  connectionKey: string;
  showActivity: string;
  onRadioChange: (value: string) => void;
}

const ClientFields = ({
  connectionKey,
  showActivity,
  onRadioChange
}: ClientFieldsProps) => {
  const navigate = useNavigate();

  return <>
      <div className="space-y-2 mb-2">
        <Button 
          type="button" 
          onClick={() => navigate('/therapists')} 
          className="w-full bg-gradient-to-r from-[#3BAFDA] to-[#333B44] hover:from-[#333B44] hover:to-[#333B44] text-white whitespace-normal py-3 sm:py-2 min-h-16 sm:min-h-0"
        >
          <span className="flex flex-col items-center justify-center sm:flex-row sm:justify-center sm:items-center">
            <UserPlus className="hidden sm:inline-block h-5 w-5 mb-0 sm:mr-2" />
            <span className="text-xs sm:text-base text-center font-medium">
              Choose a Therapist to share your journal entries. You can unshare the connection at any time.
            </span>
          </span>
        </Button>
      </div>

      <div className="space-y-2 p-3 bg-[#E8F0F8] rounded-md border border-[#CCCCCC]">
        <Label htmlFor="connectionKey" className="text-[#333B44] font-medium">Your Connection Key</Label>
        <Input id="connectionKey" type="text" value={connectionKey} readOnly className="font-mono bg-white text-center text-sm" />
        <p className="text-xs text-muted-foreground mt-1">
          Share this key with your therapist to establish a connection. You can do this via email, or if you already have a Therapist, at your next session.
        </p>
      </div>

      <div className="space-y-3">
        <Label className="text-base">Share Journal Entries with Therapist</Label>
        <RadioGroup value={showActivity} onValueChange={onRadioChange} className="flex flex-col space-y-2 pt-1">
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="yes" id="activity-yes" />
            <Label htmlFor="activity-yes" className="font-normal">
              Yes, allow my therapist to view my journal entries
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="no" id="activity-no" />
            <Label htmlFor="activity-no" className="font-normal">
              No, keep my journal entries private
            </Label>
          </div>
        </RadioGroup>
        <p className="text-xs text-muted-foreground">Your activity status (online/offline) will always be visible to your therapist.</p>
      </div>
    </>;
};

export default ClientFields;
